var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import KendoBaseComponent from '@progress/kendo-base-component-react-wrapper';
import { configuration, events, reconcileEvents, reconcileConfiguration } from './util';
import GridColumn from './GridColumn';

var Grid = function (_super) {
  __extends(Grid, _super);

  function Grid() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Grid.prototype.componentDidMount = function () {
    var domNode = ReactDOM.findDOMNode(this);

    var _a = this.enhanceProps(this.props),
        gridConfiguration = _a._configuration,
        gridEvents = _a._gridEvents,
        dataSource = _a.dataSource,
        children = _a.children;

    var options = Object.assign({}, gridConfiguration, gridEvents, {
      dataSource: dataSource
    });
    var columns = React.Children.toArray(children).filter(function (child) {
      return child && child.type === GridColumn;
    }).map(function (child) {
      return Object.assign({}, child.props);
    });

    if (columns.length > 0) {
      options = Object.assign(options, {
        columns: columns
      });
    }

    if (domNode) {
      this.widgetInstance = new kendo.ui.Grid(domNode, options);

      _super.prototype.componentDidMount.call(this);
    }
  };

  Grid.prototype.componentWillReceiveProps = function (nextProps) {
    var nextOptions = this.enhanceProps(nextProps);
    var currentOptions = this.enhanceProps(this.props);
    this.setDataSource(nextProps.dataSource);
    reconcileConfiguration(currentOptions._configuration, nextOptions._configuration, this.widgetInstance);
    reconcileEvents(currentOptions._gridEvents, nextOptions._gridEvents, this.widgetInstance);
  };

  Grid.prototype.render = function () {
    var domChild = React.Children.toArray(this.props.children).filter(function (child) {
      return child && (child.type === 'div' || child.type === 'table');
    }).shift();
    return domChild || React.createElement("div", null);
  };

  Grid.prototype.setDataSource = function (dataSource) {
    if (this.widgetInstance.options.dataSource !== dataSource) {
      this.widgetInstance.setDataSource(dataSource instanceof Array ? new kendo.data.DataSource({
        data: dataSource
      }) : dataSource);
    }
  };

  Grid.prototype.enhanceProps = function (props) {
    var _configuration = Object.create(null);

    var _gridEvents = Object.create(null);

    Object.keys(props).map(function (key) {
      if (configuration.indexOf(key) !== -1) {
        Object.defineProperty(_configuration, key, {
          enumerable: true,
          value: props[key]
        });
      } else if (events.indexOf(key) !== -1) {
        Object.defineProperty(_gridEvents, key, {
          enumerable: true,
          value: props[key]
        });
      }
    });
    return __assign({
      _configuration: _configuration,
      _gridEvents: _gridEvents
    }, props);
  };

  return Grid;
}(KendoBaseComponent);

export default Grid;